var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCaprxStackedColor = function SvgCaprxStackedColor(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "601px",
    height: "649px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "caprx-stacked-color",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 501.000000)",
    fill: "#1E4488"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.6,34.8 C186.5,34.8 177.8,39.9 170.7,45.8 L170.3,45.8 L169.2,36.8 L158.3,36.8 L158.3,147.9 L171.5,147.9 L171.5,121.4 L171.1,107.8 C178.3,113.6 185.6,116.9 192.8,116.9 C210.7,116.9 226.6,101.3 226.6,74.7 C226.5,50.5 215.7,34.8 195.6,34.8 Z M190.4,105.7 C185.2,105.7 178.4,103.5 171.4,97.6 L171.4,56.6 C179,49.6 185.7,45.9 192.3,45.9 C207,45.9 212.9,57.5 212.9,74.7 C212.9,94.1 203.3,105.7 190.4,105.7 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2,3.6 C244.1,3.6 240.1,6.9 240.1,12.1 C240.1,17.1 244.1,20.6 249.2,20.6 C254.3,20.6 258.3,17 258.3,12.1 C258.4,7 254.4,3.6 249.2,3.6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 242.5,
    y: 36.8,
    width: 13.2,
    height: 78.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.5,108.2 L426,105.5 C424.5,105.8 423.9,105.8 423.1,105.8 C421.2,105.8 419.4,104.2 419.4,100.1 L419.4,0.3 L406.2,0.3 L406.2,99.2 C406.2,110.5 410.3,116.8 420.2,116.8 C423.7,116.8 425.9,116.2 427.8,115.6 L427.2,112 L426.5,108.2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.3,106.1 C298.3,106.1 295.2,100.6 295.2,91 L295.2,47.6 L316.4,47.6 L316.4,36.8 L295.2,36.8 L295.2,14.9 L284.2,14.9 L282.6,36.8 L270.4,37.6 L270.4,47.6 L282,47.6 L282,90.8 C282,106.4 287.6,116.9 304.3,116.9 C309.2,116.9 314.4,115.5 318.8,114 L320.2,113.4 C318.1,110.7 316.5,107.6 315.5,104.3 C313.1,105.2 309.9,106.1 307.3,106.1 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5,19.3 C56.4,19.3 63.4,23.3 68.9,29.3 L76.3,20.6 C70.1,13.8 60.1,7.6 47.3,7.6 C20.5,7.6 0.5,28.4 0.5,62.4 C0.5,96.7 20.2,117 46.5,117 C55.3,117 62.7,114.7 69.1,110.5 C67.1,107 65.8,103.1 65.5,98.9 C60.2,102.9 54.2,105.2 47,105.2 C27,105.2 14.3,88.6 14.3,62.1 C14.3,35.6 27.6,19.3 47.5,19.3 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.3,34.8 C349.8,34.8 338.8,40.3 331.6,45 L336.8,54.1 C342.9,50 351.1,45.7 360.1,45.7 C372.9,45.7 376.2,55.4 376.2,65.4 C342.9,69 328.2,77.5 328.2,94.6 C328.2,108.7 338,116.8 351.1,116.8 C360.8,116.8 369.5,111.7 376.9,105.5 L377.3,105.5 L378.4,114.8 L389.3,114.8 L389.3,66.8 C389.5,47.5 381.4,34.8 362.3,34.8 Z M376.3,95.9 C368.7,102.6 362.5,106.2 354.9,106.2 C347.2,106.2 341.2,102.6 341.2,93.7 C341.2,83.7 350.1,77.3 376.2,74.1 L376.2,95.9 L376.3,95.9 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,34.8 C101.8,34.8 90.8,40.3 83.6,45 L88.8,54.1 C94.9,50 103.1,45.7 112.1,45.7 C124.9,45.7 128.2,55.4 128.2,65.4 C94.9,69 80.2,81.7 80.2,94.6 C80.2,108.7 90,116.8 103.1,116.8 C112.8,116.8 121.5,111.7 128.9,105.5 L129.3,105.5 L130.4,114.8 L141.3,114.8 L141.3,66.8 C141.5,47.5 133.4,34.8 114.3,34.8 Z M128.3,95.9 C120.7,102.6 114.5,106.2 107,106.2 C99.3,106.2 93.3,102.6 93.3,93.7 C93.3,83.7 102.2,77.3 128.3,74.1 L128.3,95.9 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.4,115.4 L578.8,81.9 L599.2,49.9 L585,49.9 L570.3,73.5 L555.8,49.9 L541.5,49.9 L561.7,81.6 C561,82.9 559.4,85.7 557.5,88.8 L555.6,91.7 C553.4,95 551,98.3 548.8,100.6 C543,106.5 534.2,105.9 529.1,99.9 C523.3,93 511.5,68.2 511.5,68.2 C525.8,64.7 535.2,54.9 535.2,38.5 C535.2,16.5 519.8,8.8 498.3,8.8 L465.2,8.8 L465.2,114.3 L478.6,114.3 L478.6,69.7 C478.6,69.7 497.7,69.7 497.7,69.7 C498,69.7 499.6,73.9 499.8,74.3 C501.6,78.1 503.4,81.8 505.3,85.6 C509.4,93.6 513.6,102.7 519.6,109.5 C524.5,114.9 531.8,117.2 540.5,117.2 C546.6,117.2 552.6,114.8 556.6,110.6 C561.3,105.5 568.4,95.2 570.6,90.7 L586.1,115.5 L600.4,115.5 L600.4,115.4 Z M496.4,58.8 L478.7,58.8 L478.7,19.7 L496.4,19.7 C512.8,19.7 521.9,24.6 521.9,38.5 C521.9,52.1 512.8,58.8 496.4,58.8 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(320.000000, 0.000000)",
    fill: "#A5BAC9"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "87.3 0.3 0 104.6 87.3 209 174.5 104.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "87.3 209 0 313.4 87.3 417.8 174.5 313.4"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1E4488",
    points: "58.3 209 145.6 104.6 232.8 0.3 407.3 0.3 320 104.6 232.8 209"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#5B89B5",
    points: "407.3 417.8 320 313.4 232.8 209 58.3 209 145.6 313.4 232.8 417.8"
  })))));
};
export { SvgCaprxStackedColor as ReactComponent };
export default __webpack_public_path__ + "static/media/caprx-stacked-color.49d8097a.svg";